import { render, staticRenderFns } from "./PageCustomerGroup.vue?vue&type=template&id=1ee3030c&"
import script from "./PageCustomerGroup.vue?vue&type=script&lang=ts&"
export * from "./PageCustomerGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports